export default __webpack_public_path__ + "static/media/discount.5b447577.svg";